import topMenu from '@/common/lang/ja/TopMenu/index'
import verification from '@/common/lang/ja/Verification'
import confirm from '@/common/lang/ja/Confirm'
import legalPerson from '@/common/lang/ja/LegalPerson'
import ekyc from '@/common/lang/ja/EKYC'
import storeInfo from '@/common/lang/ja/StoreInfo'
import settlement from '@/common/lang/ja/Settlement'
import file from '@/common/lang/ja/File'
import successPage from '@/common/lang/ja/SuccessPage'

export default {
  yes: 'はい',
  yes2: '希望します',
  un: 'いいえ',
  no: 'なし',
  and: 'あり',
  usable: '該当',
  next: '次のステップへ',
  submit: '送信',
  ok: '確認',
  edit: '変更送信',
  reset: 'リセット',
    newcreate:'ストア追加',
  homeTitle: '日本環球支付加盟店申請システム',
  start: '申請開始',
  required: '必須項目',
  no_pass: 'ありの場合、審査が通れない場合があります',
  noAccount: '当該ユーザは申請したことがありませんので、再度申請してください',
  ...topMenu,
  ...verification,
  ...confirm,
  ...legalPerson,
  ...ekyc,
  ...storeInfo,
  ...settlement,
  ...file,
  ...successPage
}
